import './App.css';
import { Void } from './ Void';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Void />
      </header>
    </div>
  );
}

export default App;
